import React from "react";
import PageHeader, { PageCTA } from "../components/PageHeader";
import Videos from "../components/Videos";

export default function VideosPage() {
  return (
    <div data-testid="page-video">
      <PageHeader
        eyebrow="Video"
        title={
          <>
            Rolki, analizy i rozmowy{" "}
            <span className="gold-gradient-text italic">z branży</span>
          </>
        }
        subtitle="Krótkie formy na TikToku, dłuższe wejścia i rozmowy na YouTubie. Jedno miejsce — cały mój content video o transporcie i spedycji."
      />
      <Videos />
      <PageCTA
        title="Masz pomysł na temat odcinka?"
        text="Napisz — jeśli zmagasz się z konkretnym problemem w firmie, mogę go poruszyć w kolejnej rolce albo odpowiedzieć na rozmowie."
        buttonLabel="Napisz do mnie"
        to="/kontakt"
      />
    </div>
  );
}
